module.exports = __webpack_public_path__ + "static/learn-at-home-d55604c38c7ca9c08d61a6c1e1089a38.jpg";